var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentinelOneColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3984 14.2162L39.7998 21.4163V14.2014L25.3984 7V14.2162Z",
    fill: "url(#paint0_linear_9537_108808)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3984 35.7873L39.7998 28.5859V35.8022L25.3984 43.0036V35.7873Z",
    fill: "url(#paint1_linear_9537_108808)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4014 14.2162L11 21.4163V14.2014L25.4014 7V14.2162Z",
    fill: "url(#paint2_linear_9537_108808)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4014 35.7873L11 28.5859V35.8022L25.4014 43.0036V35.7873Z",
    fill: "url(#paint3_linear_9537_108808)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 23.1985L28.9844 30.3944L36.1966 26.7857L21.8126 19.5938L14.5938 23.1985Z",
    fill: "url(#paint4_linear_9537_108808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9537_108808",
    x1: 39.6987,
    y1: 17.7629,
    x2: 25.3917,
    y2: 10.6007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4500B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9537_108808",
    x1: 39.6987,
    y1: 32.2405,
    x2: 25.3917,
    y2: 39.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4500B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9537_108808",
    x1: 11.1011,
    y1: 17.7629,
    x2: 25.4081,
    y2: 10.6007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9537_108808",
    x1: 11.1011,
    y1: 32.2405,
    x2: 25.4081,
    y2: 39.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9537_108808",
    x1: 33.0786,
    y1: 28.8382,
    x2: 17.5957,
    y2: 21.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentinelOneColor);
export default __webpack_public_path__ + "static/media/sentinel_one_color.71293c59df8b9246d3915c9370c826ea.svg";
export { ForwardRef as ReactComponent };